<template>
    <div v-if="isVisible" class="w-full p-4 sm:p-6 rounded-lg bg-white shadow-xl opacity-0 transition-opacity duration-300" :class="{'opacity-100': game}">
        <h4 class="font-bold">There are just 2 rules</h4>
        <ol class="list-unstyled mb-2">
            <li>1. You <strong>can't</strong> fly</li>
            <li>2. You must be in a hotel by 2am <strong>unless</strong> you have overnight transport</li>
        </ol>
        <button class="bg-blue-500 text-white text-sm px-3 py-1 rounded hover:bg-blue-600 transition" @click="isVisible = false">
            Got it!
        </button>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useGameStore } from '@/stores/useGameStore.js';

const gameStore = useGameStore();
const { game } = storeToRefs(gameStore);

const isVisible = ref(true);
</script>